import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Link } from 'react-router-dom';

const BlockBrandNavigation = inject("stores") (
    observer (
        class BlockBrandNavigation extends Component {

            constructor(props) {
                super();
                this.props = props;
                this.storeUi = this.props.stores.storeUi;
            }

            gotoSite = () => {
                const newWindow = window.open(this.props.url, '_blank', 'noopener,noreferrer');
            }

            viewLookbook = () => {
                const newWindow = window.open(this.props.lookbook, '_blank', 'noopener,noreferrer');
            }

            handleBack = () => {
                const url = "/brands";
                this.props.handleBack();
            }

            render() {
                return (
                    <React.Fragment>
                        <div class="content">
                            <div className="content__actions">
                                <div className="content__actions--brand">
                                    {this.props.lookbook !== '' &&
                                        <buton className="btn btn--primary" onClick={() => this.viewLookbook()}>Bekijk lookbook</buton>
                                    }
                                    {this.props.url !== '' &&
                                        <buton className="btn btn--primary" onClick={() => this.gotoSite()}>Bezoek website</buton>
                                    }
                                </div>
                                <div className="content__actions--site">
                                    <span className="--link" onClick={() => this.handleBack()}>Naar {this.props.section} overzicht</span>                       
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )
            }
        }
    )
)
        
export default BlockBrandNavigation;